module.exports = __webpack_public_path__ + "static/media/launch.431696d9.png";